module.exports = __webpack_public_path__ + "img/Global_College_of_PME.9f3fcc10.png";